import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthenticationService } from './services/authentication.service';
import { MessagesService } from './services/messages.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy
{
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private authService: AuthenticationService,
        private messagesService: MessagesService
    )
    {
    }

    ngOnInit(): void {
        // Iniciar polling de mensajes cuando el usuario esté autenticado
        this.authService.currentUser
            ?.pipe(takeUntil(this._unsubscribeAll))
            .subscribe(user => {
                if (user && user.authToken) {
                    // Usuario autenticado, detener polling anterior y iniciar uno nuevo
                    this.messagesService.stopPolling();
                    this.messagesService.initPolling();
                } else {
                    // Usuario no autenticado, detener polling
                    this.messagesService.stopPolling();
                }
            });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
